import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MaintenanceModeService } from './maintenance-mode.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceModeGuard implements CanActivate {
  constructor(
    private maintenanceMode: MaintenanceModeService,
    private router: Router
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.maintenanceMode.isActive().pipe(
      map(isActive => isActive ? this.router.parseUrl('/underconstruction') : true)
    );
  }
}